import { isDefined } from "repoV2/utils/common/dataTypes/common";
import { checkIsArrayEmpty } from "repoV2/utils/common/dataTypes/array";
import { ADD_VIDEO_OPTIONS } from "repoV2/pages/sale/constants";
import { callApi } from "../../../../../utils/common/api/callApi";
import { GET_SALE_PAGE_SECTIONS_DETAILS_API_URL } from "../sale.api.constants";
import { DEFAULT_SECTIONS_DATA } from "./getSalePageTemplateDataApi.constants";
import {
    IColorPaletteFromApi,
    ISalePageSectionsDataFromApi,
} from "./getSalePageTemplateDataApi.interfaces";
import {
    getPocessedBonusesListFromApi,
    getPocessedFeaturedInListFromApi,
    getPocessedTestimonialsListFromApi,
    getProcessedContentOutlineListFromApi,
    getProcessedCustomHighlightsListFromApi,
    getProcessedCustomPromoStatsListFromApi,
    getProcessedGalleryImgListFromApi,
    getProcessedCrossDataShowcaseListFromApi,
    getProcessedDemoVideoHighlightsListFromApi,
} from "./getSalePageTemplateDataApi.utils";
import { IRecordedContentCatalogueDataFromApi } from "../getRecordedContentCatalogueDataApi/getRecordedContentCatalogueDataApi.interfaces";

export const callGetSalePageTemplateDataApi = ({
    salePageUuid,
    startRange,
    endRange,
    defaultSectionsData,
    recordedContentCatalogueItemsList,
}: {
    salePageUuid: string;
    startRange?: number;
    endRange?: number;
    defaultSectionsData?: ISalePageSectionsDataFromApi;
    recordedContentCatalogueItemsList?: IRecordedContentCatalogueDataFromApi;
}) =>
    callApi({
        url: `${GET_SALE_PAGE_SECTIONS_DETAILS_API_URL}/${salePageUuid}`,
        params: {
            ...(isDefined(startRange) ? { start_range: startRange } : {}),
            ...(isDefined(endRange) ? { end_range: endRange } : {}),
        },
        extraOptions: {
            appendAuthHeaders: true,
            appendExlyOriginHeaders: true,
            appendTimezoneHeaders: true,
        },
    }).then((response: any) => {
        const unprocessedData = response?.data?.data?.section_data || {};
        const sectionsData: ISalePageSectionsDataFromApi = JSON.parse(
            JSON.stringify(defaultSectionsData || DEFAULT_SECTIONS_DATA)
        );
        const colorPalette: IColorPaletteFromApi = {};
        unprocessedData.forEach((i: any = {}) => {
            switch (i.slug) {
                case "GuranteeSection": {
                    const unprocessedGuranteeSectionData =
                        i.data?.section_data || {};
                    sectionsData.guranteeSection = {
                        title:
                            unprocessedGuranteeSectionData.title ||
                            sectionsData.guranteeSection.title,
                        shortDescription:
                            unprocessedGuranteeSectionData.short_description ||
                            sectionsData.guranteeSection.shortDescription,
                        imgSrc:
                            unprocessedGuranteeSectionData.imgSrc ||
                            sectionsData.guranteeSection.imgSrc,
                        description:
                            unprocessedGuranteeSectionData.description ||
                            sectionsData.guranteeSection.description,
                        sliderImgList:
                            unprocessedGuranteeSectionData?.sliderImgList ||
                            sectionsData.guranteeSection.sliderImgList,
                    };
                    break;
                }
                case "AboutSection": {
                    const unprocessedAboutSectionData =
                        i.data?.section_data || {};
                    sectionsData.aboutSection = {
                        progress:
                            unprocessedAboutSectionData.progress ||
                            sectionsData.aboutSection.progress,
                        title:
                            unprocessedAboutSectionData.title ||
                            sectionsData.aboutSection.title,
                        shortDescription:
                            unprocessedAboutSectionData.short_description ||
                            sectionsData.aboutSection.shortDescription,
                        overline:
                            unprocessedAboutSectionData?.overline ||
                            sectionsData.aboutSection.overline,
                        sliderImgList:
                            unprocessedAboutSectionData?.sliderImgList ||
                            sectionsData.aboutSection.sliderImgList,
                    };
                    break;
                }
                case "MoneybackSection": {
                    const unprocessedMoneybackSectionData =
                        i.data?.section_data || {};
                    sectionsData.MoneybackSection = {
                        title:
                            unprocessedMoneybackSectionData.title ||
                            sectionsData.MoneybackSection.title,
                        imgSrc:
                            unprocessedMoneybackSectionData.cover_image ||
                            sectionsData.MoneybackSection.imgSrc,
                    };
                    break;
                }
                case "StickyFooterSection": {
                    const unprocessedStickyFooterSectionData =
                        i.data?.section_data || {};
                    sectionsData.stickyFooterSection = {
                        title:
                            unprocessedStickyFooterSectionData.title ||
                            sectionsData.stickyFooterSection.title,
                        description:
                            unprocessedStickyFooterSectionData.description ||
                            sectionsData.stickyFooterSection.description,
                        showTimer:
                            unprocessedStickyFooterSectionData.showTimer ||
                            sectionsData.stickyFooterSection.showTimer,
                        timerText:
                            unprocessedStickyFooterSectionData.timertext ||
                            sectionsData.stickyFooterSection.timerText,
                    };
                    break;
                }
                case "ContactSection": {
                    const unprocessedContactSectionData =
                        i.data?.section_data || {};
                    sectionsData.ContactSection = {
                        title:
                            unprocessedContactSectionData.title ||
                            sectionsData.ContactSection.title,
                        description:
                            unprocessedContactSectionData.description ||
                            sectionsData.ContactSection.description,
                        imgSrc:
                            unprocessedContactSectionData.contact_img ||
                            sectionsData.ContactSection.imgSrc,
                    };
                    break;
                }

                case "DesiredOutcomes": {
                    const unprocessedDesiredOutcomesSectionData =
                        i.data?.section_data || {};
                    sectionsData.DesiredOutcomesSection = {
                        title:
                            i.section_name ||
                            sectionsData.DesiredOutcomesSection.title,

                        desiredOutcomesList:
                            unprocessedDesiredOutcomesSectionData.desiredOutcomesList ||
                            sectionsData.DesiredOutcomesSection
                                .desiredOutcomesList,
                        caption:
                            i.data?.section_data?.caption ||
                            sectionsData.DesiredOutcomesSection.caption,
                    };
                    break;
                }

                case "PainPointsSection": {
                    const unprocessedPainPointsSectionData =
                        i.data?.section_data?.data;
                    sectionsData.PainPointsSection = {
                        title:
                            i.section_name ||
                            sectionsData.PainPointsSection.title,
                        CheckboxList:
                            unprocessedPainPointsSectionData ||
                            sectionsData.PainPointsSection.CheckboxList,
                    };
                    break;
                }

                case "BannerImage": {
                    const unprocessedBannerImageData =
                        i.data?.section_data || {};
                    const unprocessedVideoUploadType =
                        unprocessedBannerImageData.videoUploadType;
                    let unprocessedVideoSrc;
                    switch (unprocessedVideoUploadType) {
                        case ADD_VIDEO_OPTIONS.UPLOAD_VIDEO.slug:
                            unprocessedVideoSrc =
                                unprocessedBannerImageData.video_upload_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_LINK.slug:
                            unprocessedVideoSrc =
                                unprocessedBannerImageData.video_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_EMBED_CODE.slug:
                            unprocessedVideoSrc =
                                unprocessedBannerImageData.video_embed_code;
                            break;
                        default:
                            break;
                    }
                    sectionsData.bannerImage = {
                        mediaType:
                            unprocessedBannerImageData.view_type ||
                            sectionsData.bannerImage.mediaType,
                        videoSrc:
                            unprocessedVideoSrc ||
                            sectionsData.bannerImage.videoSrc,
                        videoSrcType:
                            unprocessedVideoUploadType ||
                            sectionsData.bannerImage.videoSrcType,
                        imgSrc:
                            unprocessedBannerImageData.cover_image ||
                            sectionsData.bannerImage.imgSrc,
                        title:
                            unprocessedBannerImageData.title ||
                            sectionsData.bannerImage.title,
                        disableAutoPlay:
                            unprocessedBannerImageData.disableAutoPlay ||
                            sectionsData.bannerImage.disableAutoPlay,
                        hideControls:
                            unprocessedBannerImageData.hideControls ||
                            sectionsData.bannerImage.hideControls,
                    };
                    break;
                }
                case "RegisterButton": {
                    const unprocessedMainCtaButtonData =
                        i.data?.section_data || {};
                    sectionsData.mainCtaButton = {
                        ctaText:
                            unprocessedMainCtaButtonData.ctaText ||
                            sectionsData.mainCtaButton.ctaText,
                        strikedOffText:
                            unprocessedMainCtaButtonData.strikedOffText ||
                            sectionsData.mainCtaButton.strikedOffText,
                        delayTime: unprocessedMainCtaButtonData.addDelay
                            ? unprocessedMainCtaButtonData.delayTime
                            : sectionsData.mainCtaButton.delayTime,
                    };
                    break;
                }
                case "Requirements": {
                    const unprocessedRequirementsSectionData =
                        i.data?.section_data || {};
                    sectionsData.requirementsSection = {
                        title:
                            i.section_name ||
                            sectionsData.requirementsSection.title,
                        requirementsList:
                            unprocessedRequirementsSectionData.data?.[0]
                                ?.data ||
                            sectionsData.requirementsSection.requirementsList,
                        description:
                            unprocessedRequirementsSectionData.description ||
                            sectionsData.requirementsSection.description,
                    };
                    break;
                }
                case "FAQs": {
                    const unprocessedFAQsSectionData =
                        i.data?.section_data || {};
                    sectionsData.faqsSection = {
                        title: i.section_name || sectionsData.faqsSection.title,
                        faqsList:
                            unprocessedFAQsSectionData.data ||
                            sectionsData.faqsSection.faqsList,
                    };
                    break;
                }
                case "Contact": {
                    const unprocessedContactCreatorSectionData =
                        i.data?.section_data || {};
                    sectionsData.contactCreatorSection = {
                        title:
                            unprocessedContactCreatorSectionData.title ||
                            sectionsData.contactCreatorSection.title,
                        description:
                            unprocessedContactCreatorSectionData.description ||
                            sectionsData.contactCreatorSection.description,
                        getInTouchCtaText:
                            unprocessedContactCreatorSectionData.getInTouchCtaText ||
                            sectionsData.contactCreatorSection
                                .getInTouchCtaText,
                        getInTouchCustomCtaUrl:
                            unprocessedContactCreatorSectionData.getInTouchCustomCtaUrl ||
                            sectionsData.contactCreatorSection
                                .getInTouchCustomCtaUrl,
                    };
                    break;
                }
                case "CountdownTimer": {
                    const unprocessedCountdownTimerData =
                        i.data?.section_data || {};
                    sectionsData.countdownTimer = {
                        timerRunninngOutText:
                            unprocessedCountdownTimerData.timer_running_out_text ||
                            sectionsData.countdownTimer.timerRunninngOutText,
                        offerName:
                            unprocessedCountdownTimerData.hurry_text ||
                            sectionsData.countdownTimer.offerName,
                        startTime:
                            unprocessedCountdownTimerData.start_datetime ||
                            sectionsData.countdownTimer.startTime,
                        endTime:
                            unprocessedCountdownTimerData.end_datetime ||
                            sectionsData.countdownTimer.endTime,
                        restartCounter:
                            unprocessedCountdownTimerData.restart_counter ||
                            sectionsData.countdownTimer.restartCounter,
                    };
                    break;
                }
                case "BonusSection": {
                    const bonusesList = getPocessedBonusesListFromApi(
                        i.data?.section_data?.data
                    );
                    sectionsData.bonusesSection = {
                        title:
                            i.section_name || sectionsData.bonusesSection.title,
                        bonusesList:
                            (!checkIsArrayEmpty(bonusesList) && bonusesList) ||
                            sectionsData.bonusesSection.bonusesList,
                    };
                    break;
                }
                case "Testimonials": {
                    const unprocessedTestimonialsSectionData =
                        i.data?.section_data || {};
                    const testimonialsList = getPocessedTestimonialsListFromApi(
                        unprocessedTestimonialsSectionData.data
                    );
                    sectionsData.testimonialsSection = {
                        title:
                            i.section_name ||
                            sectionsData.testimonialsSection.title,
                        testimonialsList:
                            (!checkIsArrayEmpty(testimonialsList) &&
                                testimonialsList) ||
                            sectionsData.testimonialsSection.testimonialsList,
                        listDesign:
                            unprocessedTestimonialsSectionData.list_design ||
                            sectionsData.testimonialsSection.listDesign,
                    };
                    break;
                }
                case "Highlights": {
                    const unprocessedHighlightsSectionData =
                        i.data?.section_data?.data?.[0]?.data;
                    sectionsData.highlightsSection = {
                        title:
                            i.section_name ||
                            sectionsData.highlightsSection.title,
                        highlightsList:
                            unprocessedHighlightsSectionData ||
                            sectionsData.highlightsSection.highlightsList,
                    };
                    break;
                }
                case "Certificates": {
                    const unprocessedCertificatesSectionData =
                        i.data?.section_data || {};
                    const unprocessedVideoUploadType =
                        unprocessedCertificatesSectionData.videoUploadType;
                    let unprocessedVideoSrc;
                    switch (unprocessedVideoUploadType) {
                        case ADD_VIDEO_OPTIONS.UPLOAD_VIDEO.slug:
                            unprocessedVideoSrc =
                                unprocessedCertificatesSectionData.video_upload_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_LINK.slug:
                            unprocessedVideoSrc =
                                unprocessedCertificatesSectionData.video_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_EMBED_CODE.slug:
                            unprocessedVideoSrc =
                                unprocessedCertificatesSectionData.video_embed_code;
                            break;
                        default:
                            break;
                    }
                    sectionsData.certificatesSection = {
                        title:
                            i.section_name ||
                            sectionsData.certificatesSection.title,
                        description:
                            unprocessedCertificatesSectionData.short_description ||
                            sectionsData.certificatesSection.description,
                        imgSrc:
                            unprocessedCertificatesSectionData.cover_image ||
                            sectionsData.certificatesSection.imgSrc,
                        videoSrc:
                            unprocessedVideoSrc ||
                            sectionsData.certificatesSection.videoSrc,
                        videoSrcType:
                            unprocessedVideoUploadType ||
                            sectionsData.certificatesSection.videoSrcType,
                        mediaType:
                            unprocessedCertificatesSectionData.view_type ||
                            sectionsData.certificatesSection.mediaType,
                        pointersList:
                            unprocessedCertificatesSectionData.pointers_list ||
                            sectionsData.certificatesSection.pointersList,
                        disableAutoPlay:
                            unprocessedCertificatesSectionData.disableAutoPlay ??
                            sectionsData.certificatesSection.disableAutoPlay,
                        hideControls:
                            unprocessedCertificatesSectionData.hideControls ||
                            sectionsData.certificatesSection.hideControls,
                    };
                    break;
                }
                case "BackgroundImage": {
                    const unprocessedBackgroundImageData =
                        i.data?.section_data || {};
                    sectionsData.backgroundImage = {
                        mediaType:
                            unprocessedBackgroundImageData.view_type ||
                            sectionsData.backgroundImage.mediaType,
                        videoSrc:
                            unprocessedBackgroundImageData.background_video_url ||
                            sectionsData.backgroundImage.videoSrc,
                        imgSrc:
                            unprocessedBackgroundImageData.background_image ||
                            sectionsData.backgroundImage.imgSrc,
                    };
                    break;
                }
                case "FeaturedIn": {
                    const featuredInList = getPocessedFeaturedInListFromApi(
                        i.data?.section_data?.data
                    );
                    sectionsData.featuredInSection = {
                        title:
                            i.section_name ||
                            sectionsData.featuredInSection.title,
                        featuredInList:
                            (!checkIsArrayEmpty(featuredInList) &&
                                featuredInList) ||
                            sectionsData.featuredInSection.featuredInList,
                    };
                    break;
                }
                case "HowToBook": {
                    const unprocessedHowToParticipateSectionData =
                        i.data?.section_data?.data;
                    sectionsData.howToParticipateSection = {
                        title:
                            i.section_name ||
                            sectionsData.howToParticipateSection.title,
                        howToParticipateList:
                            unprocessedHowToParticipateSectionData ||
                            sectionsData.howToParticipateSection
                                .howToParticipateList,
                    };
                    break;
                }
                case "PromotionalStats": {
                    const unprocessedPromotionalStatsSectionData =
                        i.data?.section_data || {};
                    sectionsData.promotionalStatsSection = {
                        userCount: {
                            value:
                                unprocessedPromotionalStatsSectionData
                                    .count_data?.[0]?.value ||
                                sectionsData.promotionalStatsSection.userCount
                                    .value,
                            description:
                                unprocessedPromotionalStatsSectionData
                                    .count_data?.[0]?.description ||
                                sectionsData.promotionalStatsSection.userCount
                                    .description,
                        },
                        rating: {
                            value:
                                unprocessedPromotionalStatsSectionData
                                    .rating_data?.[0]?.value ||
                                sectionsData.promotionalStatsSection.rating
                                    .value,
                            description:
                                unprocessedPromotionalStatsSectionData
                                    .rating_data?.[0]?.description ||
                                sectionsData.promotionalStatsSection.rating
                                    .description,
                        },
                    };
                    break;
                }
                case "WhatYouWillGetToDo": {
                    const unprocessedWhatYouWillDoSectionData =
                        i.data?.section_data || {};
                    sectionsData.whatYouWillDoSection = {
                        title:
                            i.section_name ||
                            sectionsData.whatYouWillDoSection.title,
                        description:
                            unprocessedWhatYouWillDoSectionData.description ||
                            sectionsData.whatYouWillDoSection.description,
                    };
                    break;
                }
                case "WhoIsItFor": {
                    const unprocessedWhoIsItForSectionData =
                        i.data?.section_data?.data;
                    sectionsData.whoIsItForSection = {
                        title:
                            i.section_name ||
                            sectionsData.whoIsItForSection.title,
                        whoIsItForList:
                            unprocessedWhoIsItForSectionData ||
                            sectionsData.whoIsItForSection.whoIsItForList,
                    };
                    break;
                }
                case "WhatYouWillLearn": {
                    const unprocessedWhatYouWillLearnSectionData =
                        i.data?.section_data?.data;
                    sectionsData.whatYouWillLearn = {
                        title:
                            i.section_name ||
                            sectionsData.whoIsItForSection.title,
                        learnings:
                            unprocessedWhatYouWillLearnSectionData ||
                            sectionsData.whatYouWillLearn.learnings,
                    };
                    break;
                }
                case "ContentCatalogue": {
                    const unprocessedContentCatalogueSectionData =
                        i.data?.section_data || {};
                    sectionsData.contentCatalogueSection = {
                        title:
                            i.section_name ||
                            sectionsData.contentCatalogueSection.title,
                        pointersList:
                            unprocessedContentCatalogueSectionData.pointersList ||
                            sectionsData.contentCatalogueSection.pointersList,
                        catalogueItemsList:
                            recordedContentCatalogueItemsList ||
                            unprocessedContentCatalogueSectionData.catalogueItemsList ||
                            sectionsData.contentCatalogueSection
                                .catalogueItemsList,
                    };
                    break;
                }
                case "CoachIntro": {
                    const unprocessedCoachIntroSectionData =
                        i.data?.section_data || {};
                    sectionsData.coachIntroSection = {
                        coachIntro: {
                            title:
                                unprocessedCoachIntroSectionData
                                    .coach_intro_data?.[0]?.title ||
                                sectionsData.coachIntroSection.coachIntro.title,
                            description:
                                unprocessedCoachIntroSectionData
                                    .coach_intro_data?.[0]?.description ||
                                sectionsData.coachIntroSection.coachIntro
                                    .description,
                            imgSrc:
                                unprocessedCoachIntroSectionData
                                    .coach_intro_data?.[0]?.imgSrc ||
                                sectionsData.coachIntroSection.coachIntro
                                    .imgSrc,
                        },
                        rating: {
                            value:
                                unprocessedCoachIntroSectionData
                                    .rating_data?.[0]?.rating ||
                                sectionsData.coachIntroSection.rating.value,
                            description:
                                unprocessedCoachIntroSectionData
                                    .rating_data?.[0]?.rating_desc ||
                                sectionsData.coachIntroSection.rating
                                    .description,
                        },
                    };
                    break;
                }
                case "ThisCouldBeYourLife": {
                    const unprocessedThisCouldBeYourLifeSectionData =
                        i.data?.section_data || {};
                    const lifeItemsList =
                        unprocessedThisCouldBeYourLifeSectionData.data;

                    sectionsData.thisCouldBeYourLife = {
                        title:
                            i.section_name ||
                            sectionsData.thisCouldBeYourLife.title,
                        lifeItemsList:
                            (!checkIsArrayEmpty(lifeItemsList) &&
                                lifeItemsList) ||
                            sectionsData.thisCouldBeYourLife.lifeItemsList,
                    };
                    break;
                }
                case "Awards": {
                    const awardItemsList = i.data?.section_data?.data;
                    sectionsData.awards = {
                        title: i.section_name || sectionsData.awards.title,
                        awardItemsList:
                            (!checkIsArrayEmpty(awardItemsList) &&
                                awardItemsList) ||
                            sectionsData.awards.awardItemsList,
                    };
                    break;
                }
                case "WhatWillChangeInYourLife": {
                    const unprocessedWhatWillChangeInYourLifeSectionData =
                        i.data?.section_data || {};
                    const itemsList =
                        unprocessedWhatWillChangeInYourLifeSectionData.data;
                    sectionsData.whatWillChangeInYourLife = {
                        title:
                            i.section_name ||
                            sectionsData.whatWillChangeInYourLife.title,
                        itemsList:
                            (!checkIsArrayEmpty(itemsList) && itemsList) ||
                            sectionsData.whatWillChangeInYourLife.itemsList,
                    };
                    break;
                }
                case "ColourPalette": {
                    const colorPaletteList =
                        i.data?.section_data?.color_palette?.data || [];
                    colorPaletteList.forEach((j: any) => {
                        switch (j.type) {
                            case "gradient":
                                j.value.forEach((k: string, kIdx: number) => {
                                    colorPalette[`color${j.id}_${kIdx}`] = k;
                                });
                                break;
                            case "single":
                                colorPalette[`color${j.id}`] =
                                    j.value.toString();
                                break;
                            default:
                                break;
                        }
                    });
                    break;
                }
                case "DemonstrationVideo": {
                    const unprocessedDemoVideoSectionData =
                        i.data?.section_data || {};
                    const unprocessedVideoUploadType =
                        unprocessedDemoVideoSectionData.videoUploadType;
                    let unprocessedVideoSrc;
                    switch (unprocessedVideoUploadType) {
                        case ADD_VIDEO_OPTIONS.UPLOAD_VIDEO.slug:
                            unprocessedVideoSrc =
                                unprocessedDemoVideoSectionData.demo_video_upload_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_LINK.slug:
                            unprocessedVideoSrc =
                                unprocessedDemoVideoSectionData.demo_video_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_EMBED_CODE.slug:
                            unprocessedVideoSrc =
                                unprocessedDemoVideoSectionData.demo_video_embed_code;
                            break;
                        default:
                            break;
                    }
                    sectionsData.demoVideoSection = {
                        title:
                            unprocessedDemoVideoSectionData.title ||
                            sectionsData.demoVideoSection.title,
                        demoVideoSrc:
                            unprocessedVideoSrc ||
                            sectionsData.demoVideoSection.demoVideoSrc,
                        demoVideoSrcType:
                            unprocessedVideoUploadType ||
                            sectionsData.demoVideoSection.demoVideoSrcType,

                        disableAutoPlay:
                            unprocessedDemoVideoSectionData.disableAutoPlay ||
                            sectionsData.bannerImage.disableAutoPlay,
                        hideControls:
                            unprocessedDemoVideoSectionData.hideControls ||
                            sectionsData.bannerImage.hideControls,
                    };
                    break;
                }
                case "CustomPromotionalStats": {
                    const customPromoStatsList =
                        getProcessedCustomPromoStatsListFromApi(
                            i.data?.section_data?.data
                        );
                    sectionsData.customPromoStatsSection = {
                        title:
                            i.section_name ||
                            sectionsData.customPromoStatsSection.title,
                        customPromoStatsList:
                            (!checkIsArrayEmpty(customPromoStatsList) &&
                                customPromoStatsList) ||
                            sectionsData.customPromoStatsSection
                                .customPromoStatsList,
                    };
                    break;
                }
                case "AboutCreator": {
                    const unprocessedAboutCreatorData =
                        i.data?.section_data || {};
                    sectionsData.aboutCreatorSection = {
                        title:
                            unprocessedAboutCreatorData?.title ||
                            sectionsData.aboutCreatorSection.title,
                        shortDescription:
                            unprocessedAboutCreatorData?.short_description ||
                            sectionsData.aboutCreatorSection.shortDescription,
                        description:
                            unprocessedAboutCreatorData?.description ||
                            sectionsData.aboutCreatorSection.description,

                        /**
                         * for the creator img
                         * creator_img: coming from sale page CT section when user press the save (priority:1)
                         * profile_pic: coming from host page (priority:2)
                         * creatorImg: if there is no image, set it to a empty string (priority:3)
                         */
                        creatorImg:
                            unprocessedAboutCreatorData?.creator_img ?? // from sale page CT section on save
                            (unprocessedAboutCreatorData?.profile_pic || // from host page
                                sectionsData.aboutCreatorSection.creatorImg), // from default

                        socialStatsList:
                            unprocessedAboutCreatorData?.social_stats_list ||
                            sectionsData.aboutCreatorSection.socialStatsList,
                        sliderImgList:
                            unprocessedAboutCreatorData?.sliderImgList ||
                            sectionsData.aboutCreatorSection.sliderImgList,
                    };

                    break;
                }
                case "CircularBannerImage": {
                    const unprocessedCircularBannerImageData =
                        i.data?.section_data || {};
                    sectionsData.circularBannerImageSection = {
                        circularBannerImg:
                            unprocessedCircularBannerImageData?.circular_banner_img ||
                            sectionsData.circularBannerImageSection
                                .circularBannerImg,
                    };
                    break;
                }
                case "MultipleBackgroundImageSection": {
                    const unprocessedBgImagesData = i.data?.section_data || {};
                    sectionsData.multipleBackgroundImageSection = {
                        bgImages:
                            unprocessedBgImagesData?.bg_images ||
                            sectionsData.multipleBackgroundImageSection
                                .bgImages,
                    };
                    break;
                }
                case "TabAssets": {
                    const unprocessedTabAssetsData = i.data?.section_data || {};
                    sectionsData.tabAssets = {
                        title:
                            unprocessedTabAssetsData.title ||
                            sectionsData.tabAssets.title,
                        favIcon:
                            unprocessedTabAssetsData.fav_icon ||
                            sectionsData.tabAssets.favIcon,
                    };
                    break;
                }
                case "HeroSection": {
                    const unprocessedHeroSectionData =
                        i.data?.section_data || {};
                    sectionsData.heroSection = {
                        title:
                            unprocessedHeroSectionData?.title ||
                            sectionsData.heroSection.title,
                        description:
                            unprocessedHeroSectionData?.short_description ||
                            sectionsData.heroSection.description,
                        logo:
                            unprocessedHeroSectionData?.logo ||
                            sectionsData.heroSection.logo,
                    };
                    break;
                }
                case "ActionHighlightButton": {
                    const unprocessedActionHighlightBtnData =
                        i.data?.section_data || {};
                    sectionsData.actionHighlight = {
                        ctaText:
                            unprocessedActionHighlightBtnData.ctaText ||
                            sectionsData.actionHighlight.ctaText,
                        strikedOffText:
                            unprocessedActionHighlightBtnData?.strikedOffText ||
                            sectionsData.actionHighlight.strikedOffText,
                        underlineText:
                            unprocessedActionHighlightBtnData?.underlineText ||
                            sectionsData.actionHighlight.underlineText,
                        delayTime: unprocessedActionHighlightBtnData.addDelay
                            ? unprocessedActionHighlightBtnData.delayTime
                            : sectionsData.actionHighlight.delayTime,
                    };
                    break;
                }
                case "CustomHighlights": {
                    const customHighlightsList =
                        getProcessedCustomHighlightsListFromApi(
                            i.data?.section_data?.data
                        );
                    sectionsData.customHighlights = {
                        title:
                            i.section_name ||
                            sectionsData.customHighlights.title,
                        customHighlightsList:
                            (!checkIsArrayEmpty(customHighlightsList) &&
                                customHighlightsList) ||
                            sectionsData.customHighlights.customHighlightsList,
                    };
                    break;
                }
                case "CallToAction": {
                    const unprocessedCallToActionData = i?.data?.section_data;
                    sectionsData.callToAction = {
                        title:
                            unprocessedCallToActionData.title ||
                            sectionsData.callToAction.title,
                        description:
                            unprocessedCallToActionData.short_description ||
                            sectionsData.callToAction.description,
                    };
                    break;
                }
                case "AboutBrand": {
                    const unprocessedAboutBrandData = i.data?.section_data;
                    sectionsData.aboutBrandSection = {
                        title:
                            unprocessedAboutBrandData?.title ||
                            sectionsData.aboutBrandSection.title,
                        description:
                            unprocessedAboutBrandData?.short_description ||
                            sectionsData.aboutBrandSection.description,
                        brandLogo:
                            unprocessedAboutBrandData?.brand_logo ||
                            sectionsData.aboutBrandSection.brandLogo,
                    };
                    break;
                }
                case "GallerySection": {
                    const unprocessedGallerySectionData =
                        i.data?.section_data || {};
                    const unprocessedVideoUploadType =
                        unprocessedGallerySectionData.videoUploadType;
                    let unprocessedVideoSrc;
                    switch (unprocessedVideoUploadType) {
                        case ADD_VIDEO_OPTIONS.UPLOAD_VIDEO.slug:
                            unprocessedVideoSrc =
                                unprocessedGallerySectionData.gallery_video_upload_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_LINK.slug:
                            unprocessedVideoSrc =
                                unprocessedGallerySectionData.gallery_video_url;
                            break;
                        case ADD_VIDEO_OPTIONS.ADD_EMBED_CODE.slug:
                            unprocessedVideoSrc =
                                unprocessedGallerySectionData.gallery_video_embed_code;
                            break;
                        default:
                            break;
                    }
                    const galleryImgList = getProcessedGalleryImgListFromApi(
                        unprocessedGallerySectionData.data
                    );
                    sectionsData.gallerySection = {
                        galleryVideoSrc:
                            unprocessedVideoSrc ||
                            sectionsData.gallerySection.galleryVideoSrc,
                        galleryVideoSrcType:
                            unprocessedVideoUploadType ||
                            sectionsData.gallerySection.galleryVideoSrcType,
                        galleryBannerImg:
                            unprocessedGallerySectionData.gallery_img_url ||
                            sectionsData.gallerySection.galleryBannerImg,
                        galleryImgList,
                        disableAutoPlay:
                            unprocessedGallerySectionData.disableAutoPlay ??
                            sectionsData.gallerySection.disableAutoPlay,
                        hideControls:
                            unprocessedGallerySectionData.hideControls ||
                            sectionsData.gallerySection.hideControls,
                    };
                    break;
                }
                case "ContentOutline": {
                    const unprocessedContentOutlineData = i.data?.section_data;
                    const contentOutlineList =
                        getProcessedContentOutlineListFromApi(
                            unprocessedContentOutlineData?.data
                        );
                    sectionsData.contentOutline = {
                        title:
                            i.section_name ||
                            sectionsData.contentOutline.description,
                        description:
                            unprocessedContentOutlineData?.section_desc ||
                            sectionsData.contentOutline.description,
                        contentOutlineList,
                    };
                    break;
                }
                case "CrossDataShowcase": {
                    const showcaseList =
                        getProcessedCrossDataShowcaseListFromApi(
                            i.data?.section_data?.data
                        );
                    sectionsData.crossDataShowcase = {
                        title:
                            i.section_name ||
                            sectionsData.crossDataShowcase.title,
                        description:
                            i.data?.section_data?.description ||
                            sectionsData.crossDataShowcase.description,
                        showcaseList:
                            (!checkIsArrayEmpty(showcaseList) &&
                                showcaseList) ||
                            sectionsData.crossDataShowcase.showcaseList,
                    };
                    break;
                }
                case "DemoVideoHighlights": {
                    const highlightsList =
                        getProcessedDemoVideoHighlightsListFromApi(
                            i.data?.section_data?.data
                        );
                    sectionsData.demoVideoHighlights = {
                        highlightsList:
                            (!checkIsArrayEmpty(highlightsList) &&
                                highlightsList) ||
                            sectionsData.demoVideoHighlights.highlightsList,
                    };
                    break;
                }
                case "StickyText": {
                    const unprocessedStickyTextData =
                        i.data?.section_data || {};
                    sectionsData.stickyText = {
                        title:
                            unprocessedStickyTextData?.title ||
                            sectionsData.stickyText.title,
                    };
                    break;
                }
                default:
                    // tags: #test
                    // console.log("here", JSON.stringify(i));
                    break;
            }
        });
        return { sectionsData, colorPalette };
    });
